import React from 'react';
import FilterActions from './search-filter';


class SearchInput extends React.Component {
  constructor(props){
    super(props);
    this.updateFilterString = this.updateFilterString.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.setFocus = this.setFocus.bind(this);
    this.toggleFilter =this.toggleFilter.bind(this);
  }
  updateFilterString(e){
    const { onUpdate } = this.props;
    const val = e.currentTarget.value;
    onUpdate(val);
  }
  handleKeyUp(e){
    const { onKeyUp } = this.props;
    if(onKeyUp) onKeyUp(e);
  }
  setFocus(){
    this.input.focus();
  }
  toggleFilter(evt){
    const {addFilter, removeFilter, activeFilter} = this.props;
    const filterName = evt.target.dataset.filtername;
    const remove = activeFilter.includes(filterName);

    if(remove) {
      removeFilter(filterName)
    }else{
      addFilter(filterName)
    }
  }
  render(){
    const { filterString, placeholder, size, inline, darkTheme, activeFilter, filter } = this.props;
    let inputClass = 'form-control';
    inputClass += size === 'small' ? ' input-sm' : '';
    const iconSize = size === 'small' ? '17px' : '22px';
    const inputIndent = size === 'small' ? '20px' : '30px';
    return (
      <div className="form-group" style={{marginBottom:0 , display:'flex', minWidth:'220px'}}>
        <span style={{position:'absolute',fontSize: iconSize}}>
          <i className="mdi mdi-magnify" />
        </span>
          <input
            ref={(el)=>{this.input = el}}
            style={{textIndent: inputIndent, minWidth:'250px', color: darkTheme ? '#ffffff' : 'default' }}
            value={filterString}
            type="text"
            className={inputClass}
            placeholder={placeholder}
            onChange={this.updateFilterString}
            onKeyUp={this.handleKeyUp}
          />
        {/* <FilterActions toggleFilter={this.toggleFilter} activeFilter={activeFilter} filter={filter}/> */}
      </div>
    )
  }
}

export default SearchInput;